// extracted by mini-css-extract-plugin
export default {"mCard":"GF-z","image":"HF-z","imageNoBackground":"IF-z","imageHasCategory":"JF-z","fullWidth":"KF-z"};